module.exports = __webpack_public_path__ + "img/weezer.f7d6444d.jpg";